import React from 'react';
import { useRouter } from 'next/router';

import CoreMenuHeader from 'src/dispensary/core-menu/components/core-menu-header';
import PoweredByDutchie from 'src/dispensary/core-menu/components/powered-by-dutchie';
import ROUTES from 'src/routes';
import { DesktopOnly } from 'shared/components';
import DisclaimerText from 'src/dispensary/components/disclaimer-text';

import useDispensary from 'src/dispensary/hooks/use-dispensary';
import usePaths from 'hooks/use-paths';
import useUser from 'hooks/use-user';
import { useDispensaryDisclaimer } from 'src/dispensary/hooks/use-dispensary-disclaimer';
import { useCheckAgeVerification } from 'src/dispensary/core-menu/age-verification-gate/hooks';

import { LayoutWrapper } from './layout-wrapper';
import { AgeVerificationGateLayout } from './age-verification-gate-layout';

export function EmbeddedDispensaryLayout({ displayDisclaimer = true, children }) {
  const { dispensary } = useDispensary();
  const router = useRouter();
  const { route } = usePaths();
  const user = useUser();
  const { isAgeVerified, loading } = useCheckAgeVerification({ dispensaryId: dispensary?.id, userId: user?.id });

  const { disclaimerIsBlank, disclaimerTextHtml } = useDispensaryDisclaimer();

  if (!dispensary) {
    return null;
  }

  if (!loading && !isAgeVerified) {
    return <AgeVerificationGateLayout children={children} />;
  }

  return (
    <LayoutWrapper>
      <CoreMenuHeader dispensary={dispensary} />
      {children}
      {displayDisclaimer && !disclaimerIsBlank && <DisclaimerText m='50px auto' html={disclaimerTextHtml} />}
      <PoweredByDutchie />
    </LayoutWrapper>
  );
}
